module.exports = __webpack_public_path__ + "media/images/riders/small/MARK_WALLACE-a6c32ce969349cb33cb271d0dd70d94c.png";